  const urlParams = new URLSearchParams(window.location.search);
  const validationParam = urlParams.get('validation');
  const localStorageKey = 'validated_user';

  // Save to Local Storage if validated via URL param
  if (validationParam && validationParam === "EODpRRQdJVbBnsOEyxvX") {
    localStorage.setItem(localStorageKey, 'true');
  }

(function() {
    window.addEventListener('DOMContentLoaded', applyGiftMessageDiscount);
    window.addEventListener('load', applyGiftMessageDiscount);

    async function applyGiftMessageDiscount() {
        try {
            const response = await fetch('/cart.js', { cache: 'no-store' });
            const cart = await response.json();
            // console.log("Cart object:", cart);

            let eligibleForDiscount = false;
            let discountCodes = [];
          
            const discountCode16Dollar = "Gift-3BHX9ZD8CMHZ";
            const discountCode11Dollar = "Gift-AY07VS2T9176";
            const discountCode10Dollar = "Gift-6XMGYCX4DFG1";
            const discountCode9Dollar = "Gift-D1BACJ3DPXR7";
          
          

            for (let item of cart.items) {
                if (item.properties && item.properties["Gift Message"]) {
                    eligibleForDiscount = true;
                    const itemPriceInDollars = item.price / 100;

                    console.log(`Eligible item found: ${item.title} with price $${itemPriceInDollars}`);

                    if (itemPriceInDollars) {
                        if (itemPriceInDollars == 17) discountCodes.push(discountCode16Dollar);
                        else if (itemPriceInDollars == 12) discountCodes.push(discountCode11Dollar);
                        else if (itemPriceInDollars == 11) discountCodes.push(discountCode10Dollar);
                        else if (itemPriceInDollars == 10) discountCodes.push(discountCode9Dollar);
                    }
                }
            }

            if (eligibleForDiscount) {
                // console.log("Eligible for discount! Overriding all checkout buttons...");
                overrideCheckoutButtons(discountCodes);
            } else {
                // console.log("No eligible items found.");
            }
        } catch (error) {
            // console.error('Error checking eligibility:', error);
        }
    }

    function overrideCheckoutButtons(discountCode) {
        const checkoutButtons = document.querySelectorAll('button[name="checkout"]');
        checkoutButtons.forEach(button => {
            button.onclick = (event) => {
                event.preventDefault();
                // const discountQuery = discountCodes.join(",");
                window.location.href = `/checkout?discount=${discountCode}`;
            };
        });
        // console.log("Checkout buttons overridden. Discounts applied:", discountCodes);
    }

    // Monitor dynamic cart updates
    document.addEventListener('click', (event) => {
        if (event.target.matches('a[href="/cart"], button[name="add"]')) {
            setTimeout(applyGiftMessageDiscount, 1000);
        }
    });
})();
